import axios from 'axios';
import { ActionContext } from 'vuex';
import { GlobalConfig, GlobalConfigState } from '@/interfaces/config';
import { fetchBrandingData } from '@/api/config';

type Context = ActionContext<GlobalConfigState, never>;

export async function getConfig(context: Context): Promise<GlobalConfig> {
  const url = `${window.location.origin}/config.json`;
  const { data }: { data: GlobalConfig } = await axios.get(url, {
    headers: {
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  });
  context.commit('storeConfig', data);
  return data;
}

export async function getBrandingData(context: Context) {
  const brandingData = await fetchBrandingData();
  context.commit('storeBrandingConfig', brandingData.data);
  return brandingData.data;
}
